import { useEffect, useState } from "react";
import SangatiDetailsGraph from "../../components/graphs/SangatiDetailsGraph";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../../utils/apiHandler";
import { useMode } from "../../context/useMode";
import DownArrowIcon from '../../../public/icons/downarrow.svg?react';

const GraphDetailsDark = () => {
  const { setMode } = useMode();

  const handledarknav = () => {
    setMode("dark");
    navigate("/questionnaire");
  };

  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const showCompatibility = location.state?.showCompatibility;
  const UserDarkData = location.state?.UserDarkData;
  const matcheeDarkData = location.state?.MatcheeDarkData;

  const filteredUserDarkData = UserDarkData
    ? [
        UserDarkData[0],
        UserDarkData[7],
        UserDarkData[6],
        UserDarkData[5],
        UserDarkData[4],
        1000,
        1000,
        1000,
      ]
    : [];

  const filteredMatcheeDarkData = matcheeDarkData
    ? [
        matcheeDarkData[0],
        matcheeDarkData[7],
        matcheeDarkData[6],
        matcheeDarkData[5],
        matcheeDarkData[4],
        1000,
        1000,
        1000,
      ]
    : [];

  const graphs = t("graphsDark", { returnObjects: true });

  const [yDataArray, setYDataArray] = useState([]);

  const getDarkData = async () => {
    try {
      const res = await api.get("/domain_statistics?mode=dark");
      const responseData = res.data;

      const traits = [
        "extraversion",
        "agreeableness",
        "comfort_zone",
        "rule_abiding",
        "stability",
      ];

      const processedData = traits.map(trait => {
        const traitData = responseData[trait] || {};
        const yValues = Array.from(
          { length: 105 },
          (_, i) => traitData[i.toString()] ?? 0,
        );
        return yValues;
      });

      setYDataArray(processedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getDarkData();
  }, []);

  return (
    <div className="p-3 bg-bg-grey min-h-screen">
      <div className="flex justify-between items-center">
        <div onClick={() => navigate(-1)}>
          <img src="/icons/backbtn.svg" className="mb-2 p-2" alt="Back" />
        </div>
        <div onClick={handledarknav}>
          <img src="/icons/Sangati/Editgreen.svg" alt="" />
        </div>
      </div>

      {graphs.map((graph, index) => {
        const isOpen = openIndex === index;

        return (
          <div
            key={index}
            className="p-4 mb-2 rounded-[10px] border-div bg-black85 text-white max-w-md mx-auto"
          >
            <div
              className="flex justify-between items-center cursor-pointer"
              onClick={() => setOpenIndex(isOpen ? null : index)}
            >
              <h2 className="text-14">{graph.title}</h2>
              <DownArrowIcon
                role="img"
                aria-label={isOpen ? t('collapse') : t('expand')}
                className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                style={{ color: "bg-grey" }}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setOpenIndex(isOpen ? null : index);
                  }
                }}
                onClick={() => setOpenIndex(isOpen ? null : index)}
              />
            </div>

            <div
              className={`transition-all duration-1500 ease-in-out overflow-hidden ${
                isOpen
                  ? "max-h-[300px] opacity-100 translate-y-0"
                  : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-12 mt-2">{graph.description}</p>
            </div>

            <div className="relative">
              <SangatiDetailsGraph
                isOpen={isOpen}
                graphYdata={yDataArray[index]}
                showCompatibility={showCompatibility}
                userPositionValue={filteredUserDarkData?.[index]}
                matcheePositionValue={filteredMatcheeDarkData?.[index]}
                horizontalLineColor="#FDAE15"
                gradientColors={[
                  { offset: 0, color: "#FDAE15" },
                  { offset: 1, color: "#FBEAEA" },
                ]}
              />
            </div>
            <div className="flex justify-between text-sm p-1 -mt-2">
              <span className="text-12">{graph.leftLabel}</span>
              <span className="text-12">{graph.rightLabel}</span>
            </div>

            <div
              className={`transition-all duration-1500 ease-in-out overflow-hidden ${
                isOpen
                  ? "max-h-[1000px] opacity-100 translate-y-0"
                  : "max-h-0 opacity-0"
              }`}
            >
              <div className="mt-4 flex justify-between gap-4 text-sm">
                <div className="w-1/2 border-div rounded-[10px] bg-bg-grey text-black p-2 text-left">
                  <ul className="list-disc list-inside mt-1 pt-2 text-12 px-1">
                    {graph.leftTraits.map((trait, idx) => (
                      <li key={idx}>{trait}</li>
                    ))}
                  </ul>
                  <div className="absolute -top-3 left-5">
                    <img src="/icons/Sangati/eyedark.svg" alt="" />
                  </div>
                </div>
                <div className="w-1/2 border-div rounded-[10px] bg-bg-grey text-black p-2 text-left">
                  <ul className="list-disc list-inside text-12 pt-2 px-1 mt-1">
                    {graph.rightTraits.map((trait, idx) => (
                      <li key={idx}>{trait}</li>
                    ))}
                  </ul>
                  <div className="absolute -top-3 right-5">
                    <img src="/icons/Sangati/eyedark.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GraphDetailsDark;
